export const iconFontAwesomeBuildingsBuildingNgo = (
	<i className="fa-solid fa-building-ngo"></i>
);
